import { ConversationType } from "@mirage/service-conversation/router_state_types";
import { UserMessageOptions } from "@mirage/service-conversation/types";
import { ChatConversationMessage } from "../types";

/**
 * Determines whether search results should be shown in chat based on various conditions.
 *
 * @param actualLastUserMessage - The most recent user message
 * @param showSearchResultsInChat - Feature flag for search results in chat
 * @param userMessageOptions - User message options including search params
 * @param conversationType - The type of conversation (Ask, etc.)
 * @returns true if search results should be shown, false otherwise
 */
export function shouldShowSearchResultsInChat(
  actualLastUserMessage: ChatConversationMessage | undefined,
  showSearchResultsInChat: boolean,
  userMessageOptions: UserMessageOptions | undefined,
  conversationType: ConversationType | undefined,
): boolean {
  // Early exit conditions - if any of these are true, don't show search results
  if (
    actualLastUserMessage?.type !== "message" || // not a message
    !showSearchResultsInChat || // search results flag not enabled
    userMessageOptions?.searchParams?.searchTarget?.case === "noSearch" || // user selected "no search"
    (conversationType !== undefined &&
      conversationType !== ConversationType.Ask) // conversation type is defined and not Ask
  ) {
    return false;
  }

  return true;
}
